import React, { useEffect, useState } from "react";
import "./style.scss";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale, // x
    LinearScale, // y
    PointElement,
    Filler,
    Tooltip,
    Legend,
    BarElement, 
    plugins,
    scales,
    ArcElement
} from "chart.js";
import { Doughnut } from 'react-chartjs-2';
import RevenueChart from "component/admin/statistics/RevenueChart";
import CategoryRevenueChart from "component/admin/statistics/CategoryRevenueChart.js/index.js";
import VietnamMap from "component/admin/statistics/MapChart.js/index.js";
import AgegroupOrderChart from "component/admin/statistics/AgegroupOrderChart.js";
import { Formatter } from "utils/formatter";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { getAgeGroupOrderData, getCategoriesRevenueData, getRevenueByYear, getVietnamOrderData } from "services/admin/statisticsService";
import { PacmanLoader } from "react-spinners";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Filler, Tooltip, Legend, BarElement, ArcElement);

const RevenueStatistics = () => {
    const token = localStorage.getItem("token")

    const [selectedYear, setSelectedYear] = useState(dayjs().startOf('year'));
    const [salesData, setSalesData] = useState([])

    const [vietnamOrderData, setVietnamOrderData] = useState();

    const [ageGroupOrderData, setAgeGroupOrderData] = useState();

    const [categoriesRevenueData, setCategoriesRevenueData] = useState();

    // range date
    const [rangeDate, setRangeDate] = useState({
        vietnamOrderData: { start: "", end: "" },
        ageGroupOrderData: { start: "", end: "" },
        categoriesRevenueData: { start: "", end: "" },
    });

    // const formatToDate = (dateString) => {
    //   const [day, month, year] = dateString.split('/'); // Tách chuỗi bằng dấu '/'
    //   return `${year}-${month}-${day}`;
    // };
    const formatToDate = (dateString) => {
      // Tạo đối tượng Date từ chuỗi đầu vào
      const date = new Date(dateString);
    
      // Đảm bảo rằng năm, tháng, ngày đều có định dạng 2 chữ số
      const formattedYear = date.getFullYear();
      const formattedMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // Tháng bắt đầu từ 0, nên cộng thêm 1
      const formattedDay = date.getDate().toString().padStart(2, '0'); // Đảm bảo ngày có 2 chữ số
      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };
    
    

    const handleYearChange = (newDate) => {
        setSelectedYear(newDate);
    };
    useEffect(() => {
        const fetchRevenueByYear = async () => {
            const response = await getRevenueByYear(token, selectedYear.year())
            if (response && response.data ) {
                setSalesData(response.data.map(item => (
                    {
                        month: item.month.toString(),
                        sales: item.revenue
                    }
                )))
            }
        }
        fetchRevenueByYear();
    }, [token, selectedYear])

    const handleDateChange = (value, name) => {
        if (name === "vietnamOrderData") setVietnamOrderData()
        if (name === "ageGroupOrderData") setAgeGroupOrderData()
        if (name === "categoriesRevenueData") setCategoriesRevenueData()
      
        // setRangeDate((prev) => ({
        //   ...prev,
        //   [name]: {
        //     start: value ? formatToDate(value[0].toLocaleDateString()) : '',
        //     end: value ? formatToDate(value[1].toLocaleDateString()) : ''
        //   }
        // })
        // );
        setRangeDate((prev) => ({
          ...prev,
          [name]: {
            start: value ? formatToDate(value[0]) : '', 
            end: value ? formatToDate(value[1]) : ''
          }
        }));
    };
    
    useEffect(() => {
      const fetchVietnamOrderData = async () => {
        const response = await getVietnamOrderData(token, rangeDate['vietnamOrderData'])
        if (response && response.data ) {
            setVietnamOrderData(response.data.map(item => (
                {
                    name: item.city,
                    orders: +item.count
                }
            )))
        }
      }
      fetchVietnamOrderData();
    }, [token, rangeDate['vietnamOrderData']])
    
    useEffect(() => {
      const fetchAgeGroupOrderData = async () => {
        const response = await getAgeGroupOrderData(token, rangeDate['ageGroupOrderData'])
        if (response && response.data ) {
            setAgeGroupOrderData(response.data)
            console.log(response.data)
        }
      }
      fetchAgeGroupOrderData();
    }, [token, rangeDate['ageGroupOrderData']])

    useEffect(() => {
      const fetchCategoriesRevenueData = async () => {
        const response = await getCategoriesRevenueData(token, rangeDate['categoriesRevenueData'])
        if (response && response.data ) {
            setCategoriesRevenueData(response.data)
            console.log(response.data)
        }
      }
      fetchCategoriesRevenueData();
    }, [token, rangeDate['categoriesRevenueData']])

    const CancelData = {
        labels: [
          'Green',
          'Hoàn trả',
        ],
        datasets: [{
          label: 'My First Dataset',
          data: [300, 50],
          backgroundColor: [
            'rgb(255, 99, 132)',
            'rgb(54, 162, 235)',
          ],
          hoverOffset: 4
        }]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top',
          },
          tooltip: {
            callbacks: {
              // Hiển thị phần trăm trong tooltip
              label: function(tooltipItem) {
                const total = tooltipItem.dataset.data.reduce((acc, val) => acc + val, 0);
                const value = tooltipItem.raw;
                const percentage = ((value / total) * 100).toFixed(2) + '%';
                return tooltipItem.label + ': ' + percentage;
              }
            }
          }
        },
        cutout: '60%', // Cắt bỏ phần giữa của vòng tròn
        elements: {
          arc: {
            borderWidth: 2, // Đặt độ dày của đường viền cho các phân đoạn
          }
        }
    };

    // const categoriesRevenueData = [
    //   { category: 'Manga - Comic', revenue: 200100 },
    //   { category: 'Kiến thức - khoa học', revenue: 153000 },
    //   { category: 'Wings Books', revenue: 100000 },
    //   { category: 'Văn học nước ngoài', revenue: 120000 },
    //   { category: 'Combo', revenue: 80000 },
    //   { category: 'Truyện tranh', revenue: 200000 },
    //   { category: 'Văn học Việt Nam', revenue: 150000 },
    //   { category: 'Lịch sử - truyền thống', revenue: 100000 },
    //   { category: 'Khác', revenue: 120000 },
    //   { category: 'Đồ dùng', revenue: 80000 },
    //   { category: 'Sách công cụ Đoàn - Đội', revenue: 80000 },
    //   { category: 'Giải mã bản thân', revenue: 80000 },
    // ];

    const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",];

    return (
      <div className="Revenue_Statistics">
          <div className="card border-0 p-4 mt-5 mb-5">
              <div className="d-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h5 className="mb-1 ps-1">Doanh thu và tăng trưởng doanh thu</h5>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // label="Chọn năm"
                    views={['year']}
                    value={selectedYear}
                    onChange={handleYearChange}
                    maxDate={dayjs(`${dayjs().year()}-12-31`)}
                    sx={{
                        width: '15%',
                        height: 40,
                        '& .MuiInputBase-input': {
                            height: '40px',
                            padding: '0px 10px',
                            borderRadius: '8px'
                        },
                        '&:hover': {
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#9d2ff7',
                            },
                        },
                    }}   
                    renderInput={(params) => 
                      <TextField
                        {...params}
                        style={{ width: '150px', marginLeft: 'auto' }} 
                      />
                    }
                  />
                </LocalizationProvider>
              </div>
  
              <div
                  style={{
                      width: "100%",
                      height: "300px",
                      position: "relative",
                      padding: "10px",
                      cursor: "pointer",
                  }}
              >
                  <RevenueChart salesData={salesData} />
              </div>
          </div>

          <div className="card border-0 p-4 mt-5 mb-5">
            <div className="d-flex">
              <h5 className="mb-3 ps-1">Thống kê số lượng đơn hàng theo khu vực</h5>
              <DateRangePicker 
                className="ms-auto" 
                placeholder="Chọn khoảng thời gian" 
                onChange={(value) => handleDateChange(value, 'vietnamOrderData')}
                onOpen={() => {
                  setTimeout(() => {
                    const popup = document.querySelector('.rs-picker-popup');
                    if (popup) {
                      popup.style.left = '747px'; // Ghi đè giá trị left
                      popup.style.zIndex = '9999';
                    }
                  }, 50); // Tăng thời gian chờ nếu cần để đảm bảo popup đã render
                }}
              />
            </div>
            <div
              style={{
                display: 'flex', // Sử dụng Flexbox để chia nửa bản đồ và legend
                justifyContent: 'space-between',
              }}
            >
              {/* Phần bản đồ */}
              <div
                style={{
                  width: '50%',
                  height: '500px',
                  position: 'relative',
                  padding: '10px',
                  cursor: 'pointer',
                  overflow: 'hidden',
                }}
              >
                {vietnamOrderData ? (
                  <VietnamMap vietnamOrderData={vietnamOrderData}/>
                ) : (
                  <PacmanLoader color='#5e2e86' />
                )}
              </div>

              {/* Phần legend */}
              <div
                style={{
                  width: '50%',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                }}
              >
                <h6 className="mb-3">Chú thích:</h6>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <div
                    style={{
                      backgroundColor: 'red',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      marginRight: '10px',
                    }}
                  ></div>
                  <span>Top 3 tỉnh thành có số lượng đơn hàng cao nhất</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <div
                    style={{
                      backgroundColor: 'yellow',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      marginRight: '10px',
                    }}
                  ></div>
                  <span>3 tỉnh thành có số lượng đơn hàng cao tiếp theo</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      backgroundColor: 'gray',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      marginRight: '10px',
                    }}
                  ></div>
                  <span>Các tỉnh thành còn lại</span>
                </div>
              </div>
            </div>
          </div>

          <div className="card border-0 p-4 mt-5">
            <DateRangePicker 
              className="m-auto mb-3 " 
              placeholder="Chọn khoảng thời gian" 
              onChange={(value) => handleDateChange(value, 'ageGroupOrderData')}
            />
            <div className="row">
              <div className="col-6">
                <div className=" ">
                  <h5 className="mb-3 d-flex justify-content-center">Tỷ lệ đơn hàng đã bán theo độ tuổi</h5>
                  <div
                      style={{
                          width: "100%",
                          height: "300px",
                          padding: "10px",
                          cursor: "pointer",
                      }}
                  >
                    {/* <Doughnut data={CancelData}  options={options} /> */}
                    {ageGroupOrderData ? (
                      <AgegroupOrderChart ageGroupOrderData={ageGroupOrderData} />
                    ) : (
                      <PacmanLoader color='#5e2e86' />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-6">
                <div className="">
                  <h5 className="mb-5 mb-3 d-flex justify-content-center">Doanh thu theo độ tuổi</h5>
                  
                  {ageGroupOrderData && (
                      ageGroupOrderData.slice(0, 5).map((data, index) => (
                        <div key={index} className="d-flex align-items-center w-100 mb-3" >
                        <div
                            style={{
                              backgroundColor: colors[index % colors.length],
                              width: "15px",
                              height: '15px',
                              borderRadius: '50%',
                              marginRight: '10px',
                            }}
                        ></div>
                        <span style={{fontSize: '13px', flex: "0 0 45%"}}>{data.targetName}</span>
                        <span className="new text-danger" style={{ flex: "0 0 30%", fontWeight: '600' }}>{Formatter(data.revenue)}</span>
                        <div className="progressBarBox ms-auto d-flex align-items-center" style={{ width: `20%` }}>
                            <div className="progress" style={{ width: "100%" }}>
                                <div
                                    className="progress-bar"
                                    style={{ width: "100%", background: "cornflowerblue", fontWeight: '600' }}
                                >
                                {data.revenuePercent.toFixed(2)}%
                                </div>
                            </div>
                        </div>
                      </div>
                      ))
                  )}
                </div>
              </div>
            </div>
          </div>


          {/* <div className="d-flex">
            <div className="card border-0 p-4 mt-5 me-4 col-lg-6 mb-5 d-flex justify-content-center align-items-center"  style={{ flex: 1 }}>
                <h5 className="mb-3">Tỷ lệ đơn hàng đã bán theo độ tuổi</h5>
                <div
                    style={{
                        width: "100%",
                        height: "300px",
                        padding: "10px",
                        cursor: "pointer",
                    }}
                >
                 
                  {ageGroupOrderData ? (
                    <AgegroupOrderChart ageGroupOrderData={ageGroupOrderData} />
                  ) : (
                    <PacmanLoader color='#5e2e86' />
                  )}
                </div>
            </div>
            <div className="card border-0 p-4 mt-5 me-4 col-lg-6 mb-5 d-flex align-items-center"  style={{ flex: 1 }}>
                <h5 className="mb-5">Doanh thu theo độ tuổi</h5>
                <DateRangePicker 
                  className="ms-auto" 
                  placeholder="Chọn khoảng thời gian" 
                  onChange={(value) => handleDateChange(value, 'ageGroupOrderData')}
                />
                {ageGroupOrderData && (
                    ageGroupOrderData.slice(0, 5).map((data, index) => (
                      <div key={index} className="d-flex align-items-center w-100 mb-3" >
                      <div
                          style={{
                            backgroundColor: colors[index % colors.length],
                            width: "15px",
                            height: '15px',
                            borderRadius: '50%',
                            marginRight: '10px',
                          }}
                      ></div>
                      <span style={{fontSize: '13px', flex: "0 0 45%"}}>{data.targetName}</span>
                      <span className="new text-danger" style={{ flex: "0 0 30%", fontWeight: '600' }}>{Formatter(data.revenue)}</span>
                      <div className="progressBarBox ms-auto d-flex align-items-center" style={{ width: `20%` }}>
                          <div className="progress" style={{ width: "100%" }}>
                              <div
                                  className="progress-bar"
                                  style={{ width: "100%", background: "cornflowerblue", fontWeight: '600' }}
                              >
                              {data.revenuePercent.toFixed(2)}%
                              </div>
                          </div>
                      </div>
                    </div>
                    ))
                  )}
               
            </div>
          </div> */}

          <div className="card border-0 p-4 mt-5 mb-5">
              <div className="d-flex">
                <h5 className="mb-1">Thống kê doanh thu theo thể loại sách</h5>
                <DateRangePicker 
                  className="ms-auto" 
                  placeholder="Chọn khoảng thời gian" 
                  onChange={(value) => handleDateChange(value, 'categoriesRevenueData')}
                  onOpen={() => {
                    setTimeout(() => {
                      const popup = document.querySelector('.rs-picker-popup');
                      if (popup) {
                        popup.style.left = '747px'; // Ghi đè giá trị left
                        popup.style.zIndex = '9999';
                      }
                    }, 50); // Tăng thời gian chờ nếu cần để đảm bảo popup đã render
                  }}
                />
              </div>
              <div
                  style={{
                      width: "100%",
                      height: "300px",
                      position: "relative",
                      padding: "10px",
                      cursor: "pointer",
                  }}
              >
                {categoriesRevenueData ? (
                  <CategoryRevenueChart categoriesRevenueData={categoriesRevenueData} />
                ) : (
                  <PacmanLoader color='#5e2e86' />
                )}
              </div>
          </div>
      </div>
    );
}

export default RevenueStatistics;
